import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFloorUnselected = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 240,
	height: 44,
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		stroke: "#EE7400",
		strokeDasharray: "11 11",
		strokeWidth: 2,
		d: "M0 0h240v44H0z",
		style: { borderRadius: ".5rem" }
	})
});
export default SvgFloorUnselected;
